import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <p>Email: tmaaiveld@gmail.com</p>
            <p>TNO, Netherlands</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Thomas Maaiveld. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
